module.exports = __webpack_public_path__ + "static/media/back_btn.99c2d2b7.svg";